import { getDownstreamHostsValue } from "@swiggy-private/checkout-core";

export const DOWNSTREAM_HOSTS = {
    CAS_HOST: process.env.CAS_HOST ?? "https://maps.swiggy.com",
    CHECKOUT_READ_HOST: getDownstreamHostsValue("CHECKOUT_READ_HOST") ?? "https://chkout.swiggy.com",
    CBCC_API_HOST: getDownstreamHostsValue("CBCC_API_HOST") ?? "https://cbcc.swiggy.com",
    GANDALF_HOST: getDownstreamHostsValue("CART_HABIT_FORMING_HOST") ?? "https://disc.swiggy.com",
    PARTNER_REWARDS_HOST: getDownstreamHostsValue("PARTNER_REWARDS_HOST") ?? "https://spns.swiggy.com",
};

export const DOWNSTREAM_ENDPOINTS = {
    REMOVE_COUPON: "/api/v2/cart/client/removecoupon",
    FETCH_COUPONS: "/api/v2/offer/json",
};
